var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmailDefault = function SvgEmailDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.813 10.221a2.535 2.535 0 0 1-1.578-.552L4.498 6.655a.626.626 0 0 1 .784-.973l3.734 3.01c.47.372 1.13.372 1.602-.003l3.697-3.005a.624.624 0 1 1 .79.97L11.4 9.664a2.55 2.55 0 0 1-1.588.557Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "email-default_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.833.667H18.75v16.25H.833V.667Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#email-default_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.699 15.667h8.183c.002-.002.008 0 .014 0 .95 0 1.794-.34 2.44-.986.751-.747 1.164-1.821 1.164-3.024V5.934c0-2.328-1.522-4.017-3.618-4.017H5.701c-2.096 0-3.618 1.69-3.618 4.017v5.723c0 1.203.413 2.277 1.163 3.024.647.646 1.491.986 2.441.986H5.7Zm-.014 1.25c-1.286 0-2.434-.467-3.321-1.35-.988-.985-1.531-2.373-1.531-3.91V5.934C.833 2.93 2.926.667 5.701.667h8.181c2.775 0 4.868 2.264 4.868 5.267v5.723c0 1.537-.544 2.925-1.531 3.91-.886.883-2.035 1.35-3.324 1.35H5.686Z"
  }))));
};
export default SvgEmailDefault;